import { LatamAgentPage } from '@/screens/Latam/Agents/LatamAgentPage';

export default function AgentClaimsPage() {
  return <LatamAgentPage locale="en-LATAM" agentKey="claims_processing" />;
}
